import { l10n } from '@ott/l10n';
import * as yup from 'yup';
import { maxCVVLength, minCVVLength } from '../../constants';

export const getCvvValidation = () => {
  return yup
    .string()
    .required(l10n('required.required'))
    .min(minCVVLength, l10n('wrong.cardCvv'))
    .max(maxCVVLength, l10n('wrong.cardCvv'));
};
